import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import type {CustomActionMenus} from '../types';

/**
 * `getCustomActionMenu` request params
 * (what is used to send to server)
 */
export type GetCustomActionMenuRequestOptions = {};

/**
 * `getCustomActionMenu` request
 * (what gets sent to the server)
 */
export type GetCustomActionMenuRequest = [];

/**
 * `getCustomActionMenu` response
 * (what comes back from the server)
 */
export type GetCustomActionMenuResponse =
	SuccessResponse<GetCustomActionMenuResult>;

/**
 * `getCustomActionMenu` result
 * (what is utilized from the server response)
 */
export type GetCustomActionMenuResult = CustomActionMenus;

export const getCustomActionMenuEndpoint = 'getCustomActionMenu';

/**
 * Get custom action menus for user
 */
export const getCustomActionMenu = async (
	params: GetCustomActionMenuRequestOptions = {},
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: GetCustomActionMenuRequest = [];

	return client
		.post<GetCustomActionMenuResponse>(
			getCustomActionMenuEndpoint,
			requestParams,
			{signal},
		)
		.then((response) => response.data.result);
};

export default getCustomActionMenu;
